import * as React from "react"
import { Link as RouterLink } from "react-router-dom"

import { cn } from "@/common/style/classMerge"

function Link({ className, ...props }: React.ComponentProps<typeof RouterLink>) {
  return <RouterLink className={cn(className)} {...props} />
}

export { Link }
